import { Box } from "@chakra-ui/react";
import { VeriHeading } from "@verivest/shared-components";
import React from "react";
import DownloadBox from "../../../../../components/general/DownloadBox";

export interface PaymentInstructionsData {
  instructionsText?: string | null;
  instructionsUrl?: string | null;
}
export interface PaymentInstructionsProps extends PaymentInstructionsData {
  method: string;
}

export const PaymentInstructions = ({
  method,
  instructionsText,
  instructionsUrl,
}: PaymentInstructionsProps) => {
  if (!instructionsText && !instructionsUrl) {
    return null;
  }

  return (
    <Box mt="48px">
      <VeriHeading textStyle={"h3"}>{method} instructions</VeriHeading>
      {instructionsText && <Box mt="16px">{instructionsText}</Box>}
      {instructionsUrl && (
        <DownloadBox
          mt="24px"
          title={`${method} instructions`}
          href={instructionsUrl}
          filename={instructionsUrl}
        />
      )}
    </Box>
  );
};
